module.exports = __webpack_public_path__ + "media/speakers/conference@2x-e60a2a8a.png";